import { LinkOutlined, FontSizeOutlined } from "@ant-design/icons";
import dynamic from "next/dynamic";
import { LINK_PAGE_ITEM_TYPES } from "./linkPageBuilderConfig";

const LinkPagePlatformIcon = dynamic(() => import("./LinkPagePlatformIcon"));

export default function LinkPageItemIcon({ item }) {
  if (item.type === LINK_PAGE_ITEM_TYPES.TEXT) return <FontSizeOutlined />;
  if ([LINK_PAGE_ITEM_TYPES.SOCIAL, LINK_PAGE_ITEM_TYPES.CONTACT].includes(item.type)) {
    return <LinkPagePlatformIcon item={item} />;
  }
  return <LinkOutlined />;
}
